
import React from 'react'
import Navbar from '../../components/Navbar'
import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { useNavigate, } from 'react-router-dom'
import CancelIcon from '@mui/icons-material/Cancel';

const PaymentFailed = () => {
    const navigate = useNavigate()
    const navigateToWallet = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ status: "cancelled" }))
            return
        }
        if (window.electron) {
            window.electron.navigateToWallet()
            return
        }
        window.postMessage(JSON.stringify({ status: "cancelled" }))
        window.close();
    }

    return (
        <>
            <Navbar></Navbar>
            <Box sx={{ backgroundColor: "#f6f7ff", minHeight: "90vh", }}>
                <Container maxWidth="xl" sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "88vh" }}>
                    <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
                        <Grid item xs={12} sm={8} md={6} lg={4}>
                            <Box sx={{ boxShadow: "0 5px 15px rgba(0,0,0,.08)", p: { xs: 2, sm: 4 }, borderRadius: "6px" }}>
                                <Box sx={{ textAlign: "center", }}>
                                    <CancelIcon sx={{ fontSize: "60px", color: "red" }}></CancelIcon>
                                </Box>
                                <Box sx={{ mt: 1, textAlign: "center" }}>
                                    <Typography sx={{ fontWeight: 500, fontSize: { xs: "20px", sm: "26px" } }}>Payment cancelled</Typography>
                                </Box>

                                <Box sx={{ textAlign: "center", pt: 1.5 }}>
                                    <Button onClick={navigateToWallet} variant='contained'>Back to wallet</Button>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default PaymentFailed